import React, { useState, useEffect } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebaseConfig';
import { useMediaQuery } from '@mui/material';
import MobileDispatchList from './MobileDispatchList';
import { useNavigate } from 'react-router-dom';
import { getDoc, doc } from 'firebase/firestore';

const Login = ({ onLogin }: { onLogin: () => void }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const isMobile = useMediaQuery('(max-width: 767px)');
  const navigate = useNavigate();

  // 서비스 워커 등록 (PWA) - 로그인 화면에서도 시도
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('[SW] 서비스 워커 등록 성공 (Login):', registration.scope);
        })
        .catch((error) => {
          console.log('[SW] 서비스 워커 등록 실패 (Login):', error);
        });
    }
  }, []);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      // Firestore에서 role 및 탭 노출 설정 조회
      const userDoc = await getDoc(doc(db, 'users', user.email!));
      const userData = userDoc.data();
      const userConfig = {
        showStatsTab: !!userData?.showStatsTab,
        showStatsInReport: !!userData?.showStatsInReport,
        itemNameFilterType: (userData?.itemNameFilterType === 'allow' || userData?.itemNameFilterType === 'block') ? userData.itemNameFilterType : 'all',
        itemNameList: Array.isArray(userData?.itemNameList) ? userData.itemNameList : [],
        routeFilterType: userData?.routeFilterType === 'allow' ? 'allow' : 'all',
        routeList: Array.isArray(userData?.routeList)
          ? (userData.routeList as unknown[]).map(x => String(x).trim()).filter(Boolean)
          : [],
      };
      
      // 로컬 스토리지에 사용자 설정 저장
      localStorage.setItem('userConfig', JSON.stringify(userConfig));
      
      if (user.email === 'admin@swlogis.it.kr') {
        navigate('/');
      } else if (userData?.role === 'customer') {
        navigate('/customer', { state: { userConfig } });
      } else if (isMobile) {
        // 사내 사용자 + 모바일: 배차 내역 간소 화면으로 이동 (로그인 후 보여주기)
        navigate('/mobile/dispatch');
      } else {
        onLogin();
      }
    } catch (err: any) {
      setError('로그인 실패: ' + ('이메일/비밀번호를 확인하세요.'));
    }
  };

  return (
    <div style={{ textAlign: 'center', marginTop: 100 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginBottom: 32 }}>
        <img src={require('../assets/logo.png')} alt="성우로지스" style={{ width: 95, height: 50, borderRadius: 8, objectFit: 'cover' }} />
        <span style={{ fontWeight: 700, fontSize: 20, color: '#1976d2', letterSpacing: 1 }}>성우로지스</span>
      </div>
      <form onSubmit={handleLogin}>
        <div>
          <input
            type="email"
            placeholder="이메일"
            value={email}
            onChange={e => setEmail(e.target.value)}
            autoComplete="username"
            style={{ fontSize: 18, padding: 8, marginBottom: 8 }}
          />
        </div>
        <div>
          <input
            type="password"
            placeholder="비밀번호"
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoComplete="current-password"
            style={{ fontSize: 18, padding: 8, marginBottom: 8 }}
          />
        </div>
        <button type="submit" style={{ fontSize: 18, padding: '8px 24px' }}>
          로그인
        </button>
      </form>
      {error && <div style={{ color: 'red', marginTop: 12 }}>{error}</div>}
    </div>
  );
};

export default Login; 